import garden from "./garden.jpg";
import library from "./library.jpg";
import workshop from "./workshop.jpg";
import square from "./square.jpg";
import { characterImageSrc } from "@/assets/characters";

const CONTENT_CDN_BASE =
  "https://lapjkonupktxjheaefrb.supabase.co/storage/v1/object/public/content";

const LOCAL_STORY_COVERS = import.meta.glob("../generated/*/*.jpg", {
  eager: true,
  query: "?url",
  import: "default",
}) as Record<string, string>;

function folderForAgeGroup(ageGroup?: string | null): string | null {
  if (ageGroup === "4-6") return "buds";
  if (ageGroup === "7-9") return "sprouts";
  if (ageGroup === "10-12") return "fruits";
  return null;
}

/**
 * Bundled "world" cover images used as a warm, consistent fallback
 * whenever a content item has no cover_url yet. Pulled from world_id
 * via the worlds table. Keep this list in sync with `worlds.code`.
 */
export const WORLD_COVERS: Record<string, string> = {
  garden,
  library,
  workshop,
  square,
};

/** World UUIDs → cover image. Mirrors the `worlds` table. */
export const WORLD_COVERS_BY_ID: Record<string, string> = {
  "5e2d4cb5-a662-4fe4-a5d4-9550e592bf0e": garden,
  "93fe17f6-ce16-4e49-9cc3-c57580f87971": library,
  "37a89ed5-930b-44ff-a88f-a630221a173f": workshop,
  "4080d818-1113-49a0-b4fa-433535efd5fd": square,
};

export function coverFor(opts: {
  cover_url?: string | null;
  world_id?: string | null;
  age_group?: string | null;
  slug?: string | null;
  character_code?: string | null;
  character_avatar?: string | null;
}): string | null {
  const localCover = localStoryCover(opts.age_group, opts.slug);
  if (localCover) return localCover;
  if (opts.cover_url && !isTemporaryJozoriCover(opts.cover_url)) return opts.cover_url;
  const folder = folderForAgeGroup(opts.age_group);
  if (folder && opts.slug) return `${CONTENT_CDN_BASE}/covers/${folder}/${opts.slug}.jpg`;
  // Prefer the linked character's avatar so each story shows an approved
  // character image instead of repeating the same world backdrop.
  const characterCover = characterImageSrc(opts.character_code, opts.character_avatar);
  if (characterCover) return characterCover;
  if (opts.world_id && WORLD_COVERS_BY_ID[opts.world_id]) {
    return WORLD_COVERS_BY_ID[opts.world_id];
  }
  return null;
}

export function isTemporaryJozoriCover(url?: string | null): boolean {
  if (!url) return false;
  const normalized = url.toLowerCase();
  return (
    normalized.includes("/storage/v1/object/public/content/covers/") &&
    (normalized.includes("clean-20260523") || normalized.includes("info%40jozori.com") || normalized.includes("info@jozori.com"))
  );
}

function localStoryCover(ageGroup?: string | null, slug?: string | null): string | null {
  const folder = folderForAgeGroup(ageGroup);
  if (!folder || !slug) return null;
  return LOCAL_STORY_COVERS[`../generated/${folder}/${slug}.jpg`] ?? null;
}
